import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClient } from './http-client';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { dateToUnixTime } from "../utils/DateHelper";
import { DEFAULT_PAGE_SIZE } from './services-constants';
import {BehaviorSubject} from 'rxjs';
import {ClienteCUITViewModel} from '@services/remitos-service';

export const CUENTA_TYPE_CLIENTE = 1;
export const CUENTA_TYPE_PROSPECTO = 2;
export const CUENTA_TYPE_PROVEEDOR = 3;

@Injectable()
export class CuentasService {

  usuariosRolesSource = new BehaviorSubject<UsuariosRol[]>([]);
  usuariosRoles$ = this.usuariosRolesSource.asObservable();

    constructor(private httpClient: HttpClient,
                private router: Router) {

    }

    getActividad(cuentaId: string, page: number = 0){
      return this.httpClient.get(`/api/actividad/cuentas/${cuentaId}/${DEFAULT_PAGE_SIZE}/${page}`)
        .map((response: Response) => {
          return response.json();
        });
    }

    getContactos(page: number = 0, term: string = ''){
      return this.httpClient.get(`/api/contactos/${DEFAULT_PAGE_SIZE}/${page}/${term}`)
         .map((response: Response) => {
           if (response){
             return response.json().ResponseData;
           }
      });
    }

    getContacto(id: string){
      return this.httpClient.get(`/api/contacto/${id}`)
         .map((response: Response) => {
           if (response){
             return response.json().ResponseData;
           }
      });
    }

    getCuenta(id: string){
      return this.httpClient.get(`/api/cuentas/${id}`)
         .map((response: Response) => {
           if (response){
             return response.json().ResponseData;
           }
      });
    }

    /** last path item: if false -> Todas las cuentas, if true -> Cuentas Habilitadas*/
    getClientes(page: number = 0) {
      return this.httpClient.get(`/api/cuentas/clientes/${DEFAULT_PAGE_SIZE}/${page}/false`)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
         });
    }

    /** last path item: if false -> Todas las cuentas, if true -> Cuentas Habilitadas*/
    getProveedores(page: number = 0) {
      return this.httpClient.get(`/api/cuentas/proveedores/${DEFAULT_PAGE_SIZE}/${page}/false`)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
         });
    }

    /** last path item: if false -> Todas las cuentas, if true -> Cuentas Habilitadas*/
    getProspectos(page: number = 0){
      return this.httpClient.get(`/api/cuentas/prospectos/${DEFAULT_PAGE_SIZE}/${page}/false`)
        .map((response: Response) => {
          if (response){
            console.log(response.json());
            return response.json().ResponseData;
          }
         });
    }

    /** Empresas = clientes + proveedores (NO PROSPECTOS) */
    getEmpresas(page: number = 0){
      /*return Observable.forkJoin([this.getClientes(page), this.getProveedores(page)])
        .map( results => {
          return [...results[0], ...results[1]];
        });*/
      return this.httpClient.get(`/api/cuentas/clientes-proveedores/${DEFAULT_PAGE_SIZE}/${page}/false`)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
         });
    }

    addContactoToCuenta(
        cuentaId: string,
        fullName: string,
        role: string,
        phoneNumber: string,
        email: string,
        address: string,
        cellphoneNumber: string,
        primaryContact: boolean){

      let request = {
        UserId: localStorage.getItem('userId'),
        Principal: primaryContact,
        ClienteId: cuentaId,
        FullName: fullName,
        Telefono: phoneNumber,
        Email: email,
        Puesto: role,
        Domicilio: address,
        Movil: cellphoneNumber
      };

      return this.httpClient.post('/api/contacto', request)
          .map((response: Response) => {
            if (response){
              return response.json().ResponseData;
            }
       });
    }

    updateContacto(
        cuentaId: string,
        contactId: string,
        fullName: string,
        role: string,
        phoneNumber:
        string,
        email: string,
        address: string,
        cellphoneNumber: string,
        primaryContact: boolean){

      let request = {
        UserId: localStorage.getItem('userId'),
        Principal: primaryContact,
        ClientContactId: contactId,
        ClienteId: cuentaId,
        FullName: fullName,
        Telefono: phoneNumber,
        Email: email,
        Puesto: role,
        Domicilio: address,
        Movil: cellphoneNumber
      };

      return this.httpClient.put('/api/contacto', request)
          .map((response: Response) => {
            if (response){
              return response.json().ResponseData;
            }
       });
    }

    createCuenta(companyName: string,
                address: string,
                number: string,
                cuit: string,
                acopios: any[],
                tags: any[],
                contacto: any,
                type: number = CUENTA_TYPE_PROSPECTO){

      let request = {
        Domicilio: address,
        DomicilioNumero: number,
        FullName: companyName,
        Cuit: cuit,
        Acopios: acopios,
        Etiquetas: tags,
        Contacts: contacto ? [contacto] : [],
        ClientTypeId: type
      };

      return this.httpClient.post('/api/cuenta/', request)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
        });
    }

    updateCuenta(cuenta: any){
      return this.httpClient.put('/api/cuenta/', cuenta)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
        });
    }

    getCuentaTypes(){
      return this.httpClient.get(`/api/cliente-tipo`)
         .map((response: Response) => {
           if (response){
             return response.json().ResponseData;
           }
      });
    }

    deleteContacto(id: string){
      return this.httpClient.delete(`/api/contacto/${id}`)
        .map((response: Response) => {
          return response.json();
        });
    }

    deleteCuenta(id: string){
      return this.httpClient.delete(`/api/cuenta/${id}`)
        .map((response: Response) => {
          return response.json();
        });
    }

    activateCuenta(id: string){
      return this.httpClient.put(`/api/cuenta/deshabilitar/${id}`, null)
        .map((response: Response) => {
          return response.json();
        });
    }

    getEstadisticasCuenta(cuentaId) {
      return this.httpClient.get(`/api/cuentas/estadisticas/${cuentaId}`)
        .map((response: Response) => {
          return response.json();
        });
    }

    getEstadisticasContacto(contactoId) {
      return this.httpClient.get(`/api/contacto/estadisticas/${contactoId}`)
        .map((response: Response) => {
          return response.json();
        });
    }

    createLabel(text, cuentaId){
      return this.httpClient.post(`/api/etiquetas/`, {
          Etiqueta: text,
          EtiquetaTipoId: 1,
          ClientesId: [ cuentaId ]
        }).map((response: Response) => {
          return response.json();
        });
    }

    checkCuenta(name, cuit) {
      const clienteCheck = {
        ClientName: name.toUpperCase(),
        Cuit: cuit
      };

      return this.httpClient.post(`/api/cuenta/cuentacheck`, clienteCheck)
        .map((response: Response) => {
          return response.json().ResponseData;
        });

    }

    checkUserAccess(cuentaId) {
      return this.httpClient.get(`/api/cuentas/user-client/${cuentaId}`)
        .map((response: Response) => {
          return response.json();
        });
    }

    getClienteSaldo(filter) {
      return this.httpClient.post(`/api/cuenta/saldos`, filter)
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

    getAgroUsersPending(payload) {
      return this.httpClient.post(`/api/usuario-agro/get-pendientes`, payload)
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

    agroUserValidate(payload) {
      return this.httpClient.post(`/api/usuario-agro/update`, payload)
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

    agroUserEdit(payload) {
      return this.httpClient.post(`/api/usuario-agro/edit`, payload)
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

    agroGetUser(id: string) {
      return this.httpClient.get(`/api/usuario-agro/${id}`)
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

    agroGetEstados() {
      return this.httpClient.get(`/api/usuario-agro/estados`)
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

    agroGetHistory(payload) {
      return this.httpClient.post(`/api/usuario-agro/get-historial`, payload)
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

    agroEdit(payload) {
      return this.httpClient.put(`/api/usuario-agro`, payload)
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

    agroGetRazonSocial(cuit: string) {
      return this.httpClient.post(`/api/cuenta/client-agd/${cuit}`, {})
        .map((response: Response) => {
          return response.json().ResponseData;
        });
    }

    agroActivateDeactivate(userId: number, estado: boolean) {
      return this.httpClient.post(`/api/usuario-agro/activate`, {UserId: userId, Activate: estado})
        .map((response: Response) => {
          return response;
        });
    }

    agroSetupRoles() {
      if (!this.usuariosRolesSource.value.length) {
        this.agroGetRoles().subscribe(x => {
          if (x && x.length) {
            this.usuariosRolesSource.next(x);
          }
        });
      }
    }

    agroGetRoles() {
      return this.httpClient.get(`/api/usuario-agro/roles`)
        .map((response: Response) => {
          const roles = response.json().ResponseData as UsuariosRol[];
          if (roles && roles.length) {
            let indx = roles.findIndex(x => x.Id === 1);
            roles[indx].Nombre = 'Usuario AGD Agro';
            indx = roles.findIndex(x => x.Id === 5);
            roles[indx].Nombre = 'Usuario AgriPago';
          }
          return roles;
        });
    }

  getClienteByCuit(cuit: string): Observable<ClienteCUITViewModel[]> {
    const cleanCuit: string = cuit.replace(/-/g, '');
    return this.httpClient.get(`/api/cuenta/clientes/${cleanCuit}`).map((response: Response) => {
      if (response) {
        return response.json().ResponseData as ClienteCUITViewModel[];
      }
    })
  }
}

export interface UsuariosRol {Id: number, Nombre: string}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/cuentas-service.ts